import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>科技奇点</h1>
        <p>稍后再来探索</p>
      </header>
      <footer className="App-footer">
        <p>京ICP备20027991号-2</p>
      </footer>
    </div>
  );
}

export default App;
